import actionTypes from 'SRC/modules/redux/actionTypes'

export const setListings = listings => ({
  type: actionTypes.SET_ADS_LISTINGS,
  payload: listings
})
